module.exports = __webpack_public_path__ + "img/transverse_active.44f7ccae.svg";